import { FC, InputHTMLAttributes } from "react";
import { CheckboxType } from "components/atoms/Checkbox/types";
import { CheckboxInput } from "./Checkbox.styled";
interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  variant?: CheckboxType;
  id: string;
  checked: boolean;
  onChange: () => void;
  className?: string;
}
export const Checkbox: FC<CheckboxProps> = ({
  variant = CheckboxType.PRIMARY,
  id,
  checked,
  onChange,
  className,
  ...props
}) => {
  return <>
            <CheckboxInput {...props} id={id} type="checkbox" checked={checked} onChange={onChange} $variant={variant} className={className} data-sentry-element="CheckboxInput" data-sentry-source-file="index.tsx" />
            <label htmlFor={id}></label>
        </>;
};
export { CheckboxType };